import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from '../../config/axios.config'
import { axiosHeaders } from '../../utils'
// import { validateUserSession } from './UserSession.services'

export const fetchAllCombo = createAsyncThunk<
  any,
  { limit?: number; lastEvaluatedSK?: string; type?: string },
  { rejectValue: string | null }
>('combo/getalldata', async (params, thunkAPI) => {
  try {
    const response: any = await axios.get('/combo/all', {
      ...axiosHeaders(),
      params: params
    })

    if (response.status === 200) {
      return {
        data: response.data.response.data,
        key: response.data.response.lastEvaluatedSK,
        total: response.data.response.totalDataCount,
        type: params.type ? params.type : ''
      }
    } else {
      return thunkAPI.rejectWithValue(response.meta.errorDescription)
    }
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data.response)
  }
})

export const saveCombo = createAsyncThunk<
  any,
  {},
  { rejectValue: string | null }
>('combo/save', async (params, thunkApi) => {
  try {
    const response: any = await axios.post(
      '/combo/save',
      params,
      axiosHeaders()
    )

    if (response.status === 200 && response.data.response === 'success') {
      return { status: 'success' }
    } else {
      return thunkApi.rejectWithValue(response.data.meta.errorDescription)
    }
  } catch (error: any) {
    if (error.response.data.meta.errorDescription) {
      return thunkApi.rejectWithValue(error.response.data.meta.errorDescription)
    }

    return thunkApi.rejectWithValue(error.message)
  }
})

export const removeCombo = createAsyncThunk<
  any,
  { label: string },
  { rejectValue: string | null }
>('combo/delete', async (params, thunkApi) => {
  try {
    const response: any = await axios.delete(
      '/combo/' + params.label,
      axiosHeaders()
    )

    if (response.status === 200 && response.data.response === 'success') {
      return { status: 'success' }
    } else {
      return thunkApi.rejectWithValue(response.data.meta.errorDescription)
    }
  } catch (error: any) {
    if (error.response.data.meta.errorDescription) {
      return thunkApi.rejectWithValue(error.response.data.meta.errorDescription)
    }

    return thunkApi.rejectWithValue(error.message)
  }
})

export const getCombo = createAsyncThunk<
  any,
  { label: string; editMode: boolean },
  { rejectValue: string | null }
>('combo/getdata', async (params, thunkAPI) => {
  try {
    const response: any = await axios.get(
      '/combo/' + params.label,
      axiosHeaders()
    )

    if (response.status === 200) {
      return { data: response.data.response, editMode: params.editMode }
    } else {
      return thunkAPI.rejectWithValue(response.meta.errorDescription)
    }
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data.response)
  }
})

export const enableCombo = createAsyncThunk<
  any,
  { label: string; status: string },
  { rejectValue: string | null }
>('combo/enable', async (params, thunkAPI) => {
  try {
    const response: any = await axios.patch(
      '/combo/' + params.label + '/' + params.status,
      {},
      axiosHeaders()
    )

    if (response.status === 200) {
      return { status: response.data.response }
    } else {
      return thunkAPI.rejectWithValue(response.meta.errorDescription)
    }
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data.response)
  }
})

export const updateCombo = createAsyncThunk<
  any,
  { label: string; params: object },
  { rejectValue: string | null }
>('combo/update', async (params, thunkAPI) => {
  try {
    const response: any = await axios.post(
      '/combo/update/' + params.label,
      params.params,
      axiosHeaders()
    )

    if (response.status === 200) {
      return { status: response.data.response }
    } else {
      return thunkAPI.rejectWithValue(response.meta.errorDescription)
    }
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data.response)
  }
})
